<template>
  <section class="campaign">
    <Header :user="user" />
    <main class="main">
      <div class="row p-3">
        <h4 class="ml-3">Campaigns Health</h4>
        <div class="col-md-12  pl-4">
          <Tabs
            :tabSelected="typelist"
            :tabs="tabs"
            @change="tabschanged($event)"
          />
        </div>
        <div class="col-md-12 pl-4" v-if="hasSubtabs(typelist)">
          <Tabs
            :tabSelected="typelist"
            :tabs="subtabs"
            @change="tabschanged($event)"
          />
        </div>
        <div class="col-md-12" v-if="typelist==14">
          <button class="icon-refresh btn btn-sm btn-primary ml-2" @click="refresh()"></button>
            <Table
              v-if="resultsearching.length > 0"
                :headers="headers"
                :data="resultsearching"
                :cols="cols"
                :notselect="true"
                @openTarget="openTarget"
                >
                </Table>
                    <Modal
                    name="target"
                    :close="true"
                      >
                        <div class="row">
                        <div class="col-12">
                        <TargetCampaigns   v-if="target_id"
                          :target_id="target_id"
                          :selected="selected"
                          countselected="countselected"
                        ></TargetCampaigns>
                        </div>
                        </div>
                    </Modal>
        </div>

      </div>

      <div class="col-md-12" v-if="[32].includes(typelist)">
        <div class="card m-2 p-2 text-center">
            
            <CampaignProgressBarEmails></CampaignProgressBarEmails>

        </div>
      </div>

      <div v-if="!loadingapi && typelist == 6" class="row mx-1">
        <div class="col-12 px-4">
          <button @click="refresh()" class="btn btn-sm btn-primary mb-1">
            <i class="icon-refresh"></i>
          </button>
          <div class="row mb-2">    <!-- Margin bottom entre los divs y la barra LoadingOliver -->
            <div v-for="ak in apikeys" class="col-md-3  p-2">
              <div class="w-100 float-left">
                <strong><small>{{ ak.account }}</small></strong>
              </div>
              <div class="row px-3 pt-1">
                <small :class="ak.finished == '1' ? 'text-danger' : 'text-success'">{{
                  ak.api
                }}</small>
              </div>
             
            
            <div>
              <small class=""
                >Request made: {{ ak.x_rate_limit_24_hour - ak.x_24_hour_requests_left }} of
                {{ ak.x_rate_limit_24_hour }}</small
              >
            </div>
            <div v-if="ak.finished == '1'">
              <small class="float-left text-secondary">
              <span class="badge badge-danger" v-if="ak.error">finished</span>
              <span class="badge badge-success text-white" v-else="ak.error">running</span>
              {{ ak.error }} ({{ak.updated}})</small>
            </div>
            <div v-else>
              <small class="float-left text-secondary">
              <span class="badge badge-success text-white">running</span>
               ({{ak.updated}})</small>
            </div>
            </div>
          </div>

      <div class="row my-3 card py-3" v-if="open && false">
        <h6 class="ml-3">Contacts Enriched</h6>
        <LoadingOliver v-if="loadingenrich" />
        <div class="col-12" v-if="businessEnrich.length > 0 && !loadingenrich">
            <span>Contacts with Business Enriched <small>(With Country, Linkedin Category & salaries)</small></span>
              <div
              class="progress border bg-secondary"
              style="height: 15px">
              <div
                class="progress-bar bg-primary pl-2 bg-success"
                role="progressbar"
                :style="'width:'+getPercentageAvailable(totalEnriched[0].business,(parseInt(totalEnriched[0].business)+parseInt(totalEnriched[1].business)))+'%'">
              </div>
              <small class="text-white">{{totalEnriched[0].business}} ({{getPercentageAvailable(totalEnriched[0].business,(parseInt(totalEnriched[0].business)+parseInt(totalEnriched[1].business)))}}%)</small>
              </div>

            <span>Contacts with Business Enriched with apollo <small>(With Country, Linkedin Category & salaries)</small></span>
            <div
              class="progress border bg-secondary"
              style="height: 15px">
              <div
                class="progress-bar bg-primary pl-2 bg-success"
                role="progressbar"
                :style="'width:'+getPercentageAvailable(businessEnrich[0].business,totalbusiness)+'%'"></div>
              <small class="text-white">{{getPercentageAvailable(businessEnrich[0].business,totalbusiness)}}%</small>
              </div>
              <span>Contacts with Business Enriched with apollo + keywords <small>(With Country, Linkedin Category & salaries + Industry keywords)</small></span>
                <div
                class="progress border bg-secondary"
                style="height: 15px">
                  <div
                    class="progress-bar bg-primary pl-2 bg-success"
                    role="progressbar"
                    :style="'width:'+getPercentageAvailable(businessEnrich[1].business,totalbusiness)+'%'">
                    </div>
                   <small class="text-white">{{getPercentageAvailable(businessEnrich[1].business,totalbusiness)}}%</small>
                </div>

                <div class="row card my-2 mx-1 py-2">
                  <div class="col-12">Total: {{totalbusiness}}</div>
                  <div v-for="bus in businessEnrich" class="col-12">{{bus.id_type}}: {{bus.business}}</div>
                </div>
              </div>
          </div>

        <div class="row my-3 card py-3" v-if="open && false">
            <h6 class="ml-3">Contacts</h6>
            <LoadingOliver v-if="loadingcontenrich" />
            <div class="col-12" v-if="contactsEnrich.length > 0 && !loadingcontenrich">
                <div class="row card my-2 mx-1 py-2">
                  <div v-for="bus in contactsEnrich" class="col-12">{{bus.name}}: {{bus.contacts}}</div>
                </div>
            </div>
        </div>

        </div>
      </div>


        <SearchSituation v-if="typelist==8"></SearchSituation>

      <div v-if="!loading && ![6, 7, 8].includes(typelist) && open" class="row p-4" >
        <div class="col-12" v-if="typelist == 2">
          <button
            @click="selectSentProblems()"
            v-if="!calculating && countselected == 0"
            class="btn btn-small btn-outline-primary"
          >
            Select only sent problems
          </button>
          <button
            @click="unselectAll()"
            v-if="!calculating && countselected > 0"
            class="btn btn-small btn-outline-primary"
          >
            Unselect all
          </button>
        </div>
        <div class="col-12" v-if="typelist == 1 || typelist == 2">
          <span v-if="countselected > 0 && processedcount < countselected">
            Calculate available ({{ countselected }})
            <button
              @click="calculateAll()"
              v-if="!calculating"
              class="btn btn-small btn-primary"
            >
              Start
            </button>
          </span>
          <div
            v-if="countselected > 0"
            class="progress mb-2 border bg-secondary"
            style="height: 15px"
          >
            <div
              class="progress-bar bg-primary pl-2 bg-success"
              role="progressbar"
              :style="
                'width:' +
                getPercentageAvailable(processedcount, countselected) +
                '%;'
              "
            ></div>
            <small class="text-white"
              >{{
                getPercentageAvailable(processedcount, countselected)
              }}%</small
            >
          </div>
        </div>


           <TargetCampaigns
              v-if="!loading && resulttarget.length  > 0"
              :resulttarget="resulttarget"
              :selected="selected"
              :typelist="typelist"
              countselected="countselected"
            ></TargetCampaigns>

      </div>
       <LoadingOliver v-if="(loading || loadingapi)" />
    </main>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import Tabs from "@/components/Common/Tabs.vue";
import CampaignProgressBarEmails from "@/components/Campaigns/CampaignProgressBarEmails.vue";
import SearchSituation from "@/components/SearchSituation/SearchSituation.vue";
import TargetSituation from "@/components/SearchSituation/TargetSituation.vue";
import TargetCampaigns from "@/components/Campaigns/TargetCampaigns.vue";
import { campaignsService, targetsService, monitorService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import ToastNotifications from "@/components/ToastNotifications.vue";
import LoadingOliver from "@/components/LoadingOliver.vue";

export default {
  data() {
    return {
      open:true,
      target_id:false,
      businessEnrich: [],
      resultsearching: [],
      showtargets: [],
      contactsEnrich: [],
      totalEnriched:[],
      totalbusiness:0,
      loadingenrich:false,
      loadingcontenrich:false,
      resulttarget: [],
      totaltargets: 0,
      calculating: false,
      countselected: 0,
      processedcount: 0,
      loadingapi: false,
      quantity: [],
      quantitycalls: [],
      selected: [],
      cols:[
          [{
          'value' : 'the_success',
          }],
          [{
          'value' : 'campaigns',
          'badges' : [{
              'badge_if' : 'in_queue',
              'badge_value' : 1,
              'badge_class' : 'badge badge-primary text-white',
              'badge_icon' : 'icon-play',
              },
              {
              'badge_if' : 'in_queue',
              'badge_value' : 0,
              'badge_class' : 'badge badge-danger text-white',
              'badge_icon' : 'icon-stop',
              }],
          }],
          [
            {
              value_label: "target_id",
              value_emit: "target_id",
              class: "text-primary",
              type: "emit",
              emit: "openTarget",
            },
          ],
          [{
          'value' : 'cycles',
          'badges' : [{
              'badge_if' : 'finished',
              'badge_value' : 0,
              'badge_class' : 'badge badge-primary text-white',
              'badge_icon' : 'icon-play',
              },
              {
              'badge_if' : 'finished',
              'badge_value' : 1,
              'badge_class' : 'badge badge-danger text-white',
              'badge_icon' : 'icon-stop',
              }],
          }],
          [{
          'value' : 'apollo_actual_page',
          }],
          [{
          'value' : 'last_execution',
          }],
          [
            {
              value_label: "cant",
              value_emit: "cant",
              class: "icon-play h6",
              type: "emit"
            }
          ],
          [
            {
              value_label: "found",
              value_emit: "found",
              class: "icon-download h6",
              type: "emit"
            }
          ],
          [
            {
              value_label: "available_contacts",
              value_emit: "available_contacts",
              class: "icon-user h6",
              type: "emit"
            }
          ],
          [
            {
              value_label: "meeting_rate",
              value_emit: "meeting_rate",
              class: "icon-calendar h6",
              type: "emit"
            }
          ],
          [
            {
              value_label: "search_success",
              value_emit: "search_success",
              class: "icon-search h6",
              type: "emit"
            }
          ],
          [{
          'value' : 'new_emails_cant',
          }],
          [{
          'value' : 'contacts_found',
          }],
          [{
          'value' : 'total_contacts',
          }]
      ],
      headers: [
          {
            'label' : 'Ranking',
            'percentage':'20%',
            'class':'overflowhide'
          },
          {
            'label' : 'Campaign id',
            'percentage':'20%',
            'class':'overflowhide'
          },
          {
            'label' : 'Target ID',
            'percentage':'20%',
            'class':'overflowhide'
          },
          {
            'label' : 'Cycles',
            'percentage':'20%',
            'class':'overflowhide'
          },
          {
            'label' : 'Actual page',
            'percentage':'20%',
            'class':'overflowhide'
          },
          {
            'label' : 'Last execution',
            'percentage':'20%',
            'class':'overflowhide'
          },
          {
            'label' : 'Executions 24hs',
            'percentage':'20%',
            'class':'overflowhide'
          },
          {
            'label' : 'Imported 24hs',
            'percentage':'20%',
            'class':'overflowhide'
          },
          {
            'label' : 'Available contacts',
            'percentage':'20%',
            'class':'overflowhide'
          },
          {
            'label' : 'Meeting Rate',
            'percentage':'20%',
            'class':'overflowhide'
          },
          {
            'label' : 'Search Rate',
            'percentage':'20%',
            'class':'overflowhide'
          },
          {
            'label' : 'New emails Tomorrow',
            'percentage':'20%',
            'class':'overflowhide'
          },
          {
            'label' : 'Contacts found rate',
            'percentage':'20%',
            'class':'overflowhide'
          },
          {
            'label' : 'Total contacts',
            'percentage':'20%',
            'class':'overflowhide'
          }
      ],
      tabs: [
        {
          id: 13,
          name: 'Targets',
        },
        {
          id: 1,
          name: this.$t("lang.column.problemsDetected"),
        },
        {
          id: 8,
          name: 'Situation Monitor',
        },
        {
          id: 3,
          name: this.$t("lang.column.targetfinished"),
        },
        {
          id: 6,
          name: this.$t("lang.column.apiKeys"),
        },
        {
          id: 32,
          name: "Targets situation",
        },
      ],
      subtabs: [
        {
          id: 4,
          name: 'All',
          icon: 'icon-list'
        },
        {
          id: 10,
          name: 'Working',
          icon: 'icon-search'
        },
        {
          id: 9,
          name: 'Working with Priority',
          icon: 'icon-star'
        },
        {
          id: 11,
          name: 'Finished',
          icon: 'icon-close'
        },
        {
          id: 12,
          name: 'Waiting',
          icon: 'icon-clock'
        },
        {
          id: 14,
          name: 'Campaign active searching',
          icon: 'icon-play'
        },
      ],
      loading: false,
      typelist: 8,
      list: [],
      total: 0,
      available_contacts: 0,
      apikeys: [],
      available_apis: 0,
      expired_api: 0,
      emails_sent: 0,
      total_emails: 0,
      targetMissinDataItems: [],
    };
  },

  mounted() {},

  created() {
  switch (this.typelist) {
    case 6:
      this.getApiKeys();
      this.getApolloEnrich();
      break;
    case 8:
      break;
    default:
      this.getCampaignsProblems(this.typelist);
      break;
  }

    this.setHeader();
  },

  components: {
    LoadingOliver,
    Tabs,
    SearchSituation,
    TargetSituation,
    TargetCampaigns,
    Table,
    CampaignProgressBarEmails
  },

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
  },

  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    hasSubtabs(){
      let arr = [13,9,10,11,12,4,14];
      return arr.indexOf(this.typelist) != -1
    },
    openTarget(target_id) {
        this.target_id = target_id
        this.$modal.show('target');
    },
    getApolloEnrich(){
      this.loadingenrich = true
      monitorService.getApolloEnrich('totalbusiness-idtype').then((res) => {

        res.forEach(res => {

          this.totalbusiness = this.totalbusiness + parseInt(res.business)

          if(res.id_type == 'enriched'){
             this.businessEnrich[0] = {
                    'id_type':'Enriched (process 100 items x credit)',
                    'business': res.business
                }
          }else{
            if(res.id_type == 'enriched-with-keywords'){
               this.businessEnrich[1] = {
                      'id_type':'Enriched with Keywords (With business contact email 1 credit x page)',
                      'business': res.business
                  }
            }else{
                if(this.businessEnrich[2] !== undefined){
                   this.businessEnrich[2] = {
                          'id_type':'Not enriched',
                          'business': parseInt(this.businessEnrich[2].business) + parseInt(res.business)
                    }
                }else{
                   this.businessEnrich[2] = {
                          'id_type':'Not enriched',
                          'business': res.business
                    }
                }
            }
          }
        })

        this.loadingenrich = false


      });

      this.loadingcontenrich = true
      monitorService.getApolloEnrich('totalcontacts-type').then((res) => {
          this.contactsEnrich = res

        this.loadingcontenrich = false
      });
      monitorService.getApolloEnrich('totalenriched').then((res) => {
          this.totalEnriched = res
      });


    },
    getTotalQuantityApi(ak) {
      if (ak.api == "IPygwl6Rdw2kSl9SJ9n7iQ") {
        return 1000;
      }
      return 300;
    },
    getClassCols(cant) {
      if (cant == 1) {
        return "col-md-3";
      }
      if (cant == 2) {
        return "col-md-6";
      }
      if (cant == 3) {
        return "col-md-9";
      }
      if (cant > 3) {
        return "col-md-12";
      }
    },
    getClassCols2(cant) {
      if (cant == 1) {
        return "col-md-12";
      }
      if (cant == 2) {
        return "col-md-6";
      }
      if (cant == 3) {
        return "col-md-4";
      }
      if (cant > 3) {
        return "col-md-3";
      }
    },
    calculateAvailable(campaign_id) {
      this.loading = true;
      campaignsService.calculateAvailableContacts(campaign_id).then((res) => {
        this.refresh();
      });
    },
    selectSentProblems() {
      this.list.forEach((res) => {
        if (res.new_emails == null) {
          res.new_emails = 0;
        }
        if (res.new_emails == 0) {
          this.select(res.campaigns);
        }
      });
    },
    quantityTotal() {
      let total;
      let totalt;
      total = 0;
      totalt = 0;
      this.quantity.forEach((res) => {
        total = parseInt(total) + parseInt(res);
        totalt++;
      });

      this.totaltargets = totalt;
      return total;
    },
    quantityCallsTotal() {
      let total;
      let totalt;
      total = 0;
      totalt = 0;
      this.quantitycalls.forEach((res) => {
        total = parseInt(total) + parseInt(res);
        totalt++;
      });

      this.totalcalls = totalt;
      return total;
    },
    calculateAll() {
      this.calculating = true;
      this.selected.forEach((r) => {
        if (r) {
          let campaign_id = r;
          this.selected[r] = false;
          campaignsService
            .calculateAvailableContacts(campaign_id)
            .then((res) => {
              this.calculateAll();
              this.processedcount++;
              if (this.processedcount >= this.countselected) {
                this.calculating = false;
                this.refresh();
              }
              return;
            });
        }
      });
    },
    calculateSelected() {
      this.countselected = 0;
      this.selected.forEach((r) => {
        if (r) {
          this.countselected++;
        }
      });
    },
    select(campaign_id) {
      this.selected[campaign_id] = campaign_id;
      this.calculateSelected();
      this.$forceUpdate();
    },
    unselect(campaign_id) {
      delete this.selected[campaign_id];
      this.calculateSelected();
      this.$forceUpdate();
    },
    unselectAll() {
      this.selected = [];
      this.countselected = 0;
    },
    setHeader() {
      this.setCurrentRoute({ page: "campaigns", label: "Camp. Health" });
    },
    tabschanged(id) {
      this.loading = false;
      this.loadingapi = false;
      this.typelist = id;
      this.refresh();
    },
    refresh() {
    this.resultsearching=[]
    this.showtargets = []
      this.resulttarget = []
      this.loading=true
      switch (this.typelist) {
        case 6:
          this.getApiKeys();
          break;
        case 8:
          this.loading = false;
          break;
        case 14:
          targetsService.apolloSearching().then((result) => {
              this.resultsearching = result;
              this.loading=false
          })
          break;
        default:
          (this.resulttarget = []), (this.totaltargets = 0), (this.quantity = []);
          this.quantitycalls = [];
          (this.countselected = 0),
            (this.processedcount = 0),
            (this.selected = []),
            (this.list = []),
            (this.total = 0),
            (this.available_contacts = 0),
            (this.apikeys = []),
            (this.available_apis = 0),
            (this.expired_api = 0),
            (this.emails_sent = 0),
            (this.total_emails = 0);
          this.getCampaignsProblems(this.typelist);
          this.getApiKeys();
          break;
      }

    },
    getPercentageAvailable(available, total) {
      if (available == null) {
        available = 0;
      }
      if (total == null) {
        total = 0;
      }
      if (available == 0 && total == 0) {
        return 0;
      }
      return Math.round((available * 100) / total);
    },



    getCampaignsProblems(type) {
      this.loading = true;
      let actualtarget = 0;
      campaignsService.getCampaignsProblems(type).then((result) => {
        this.list = result;
        this.resulttarget = [];
        let targets = [];
        this.list.forEach((res) => {
          res.changetarget = false;

          if(this.showtargets.indexOf(res.target_id) == -1){

            if (res.target_id !== actualtarget) {
              if(actualtarget != 0){
                this.showtargets.push(actualtarget)
              }

              res.changetarget = true;
              actualtarget = res.target_id;
              this.resulttarget.push(targets);
              targets = [];
            }



            targets.push(res);

            if (res.email_volume == null) {
              res.email_volume = 0;
            }
            if (res.emails_sent == null) {
              res.emails_sent = 0;
            }
            if (res.new_emails == null) {
              res.new_emails = 0;
            }
            if (res.available_contacts == null) {
              res.available_contacts = 0;
            }
            this.total_emails =
              parseInt(this.total_emails) + parseInt(res.email_volume);
            this.emails_sent =
              parseInt(this.emails_sent) + parseInt(res.new_emails);
            this.available_contacts =
              parseInt(this.available_contacts) +
              parseInt(res.available_contacts);
            this.total = parseInt(this.total) + parseInt(res.email_volume);
            this.quantity[res.target_id] = res.quantity;
            this.quantitycalls[res.target_id] = res.calls;
          }
        });
          this.loading = false;
          this.loadingapi = false;
        this.resulttarget.push(targets);
      });
    },
    getApiKeys() {
      this.loadingapi = true;

      targetsService.getApiKeys().then((result) => {
        this.apikeys = result;

        // Ordenar los apikeys por 'updated' (si 'updated' es un campo en tus objetos)
        this.apikeys.sort((a, b) => {
          // Asegúrate de que 'updated' esté en el formato correcto para la comparación
          return new Date(b.updated) - new Date(a.updated);
        });

        this.apikeys.forEach((res) => {
          if (res.finished == 1) {
            this.expired_api++;
          } else {
            this.available_apis++;
          }
        });

        this.loadingapi = false;
        this.loading = false;
      });
    },
  },
};
</script>
